// extracted by mini-css-extract-plugin
export var fadeIn = "Badge-module--fadeIn--g1fk5";
export var show = "Badge-module--show---Iv1r";
export var wrapper = "Badge-module--wrapper--YohpI";